module.exports = __webpack_public_path__ + "img/blue2.bb1e3b6d.jpg";